<template>
	<el-row>
		<el-button type="primar=" @click="addZy()">创建作业+</el-button>
		<el-table :data="tableDate" style="margin-top: 20px;">
			<el-table-column label="作业id" width="60px" prop="id"></el-table-column>
			<el-table-column label="作业标题" width="400px" prop="title"></el-table-column>
			<el-table-column label="批改/参与">
				<template slot-scope="scope">
					{{scope.row.correct}}/{{scope.row.participate}}人
				</template>
			</el-table-column>
			</el-table-column>
			<el-table-column label="关联课时" prop="lessonName">
			</el-table-column>
			<el-table-column label="创建人" prop="createdUserName"></el-table-column>
			<el-table-column label="状态">
				<template slot-scope="scope">
					<el-switch :active-value="1" :inactive-value="0" @change="isStatus(scope.row)" active-text="启用"
						inactive-text="禁用" v-model="scope.row.status">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="创建时间" prop="createdAt"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="mini" @click="bianji(scope.row)">编辑</el-button>
					<el-button type="text" size="mini" @click="pigai(scope.row)">批改作业</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="30%" center @close="gb()">
			<el-form ref="info" :model="info" label-width="90px" label-position="right">
				<el-form-item label="作业标题:" prop="title" :rules="[{
					required: true,trigger: 'blur',message: '请输入作业标题'}]">
					<el-input v-model="info.title" style="width: 100%;"></el-input>
				</el-form-item>
				<!-- <el-form-item label="参与人数:" prop="participate" :rules="[{
					required: true,trigger: 'blur',message: '请输入参与人数'}]">
					<el-input v-model="info.participate" style="width: 150px;" type="number"></el-input>人
				</el-form-item>
				<el-form-item label="批改人数:" prop="correct" :rules="[{
					required: true,trigger: 'blur',message: '请输入批改人数'}]">
					<el-input v-model="info.correct" style="width: 150px;" type="number"></el-input>人
				</el-form-item> -->
				<el-form-item label="关联课时:" prop="courseId" :rules="[{
					required: true,trigger: 'blur',message: '请选择课程'}]">
					<el-cascader size="mini" v-model="info.courseId" :options="options" :props="cateListProps" clearable
						:disabled="disabled" />
				</el-form-item>
				<el-form-item label="状态:" prop="status" :rules="[{
					required: true,trigger: 'blur',message: '请选择状态'}]">
					<el-radio-group v-model="info.status">
						<el-radio :label="1">开启</el-radio>
						<el-radio :label="0">关闭</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item>
					<el-button @click="centerDialogVisible=false">取消</el-button>
					<el-button type="primary" @click="queren()">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				disabled: false,
				tableDate: [],
				pageNum: 1,
				pageSize: 30,
				total: 0,
				pagelist: [30, 60, 100],
				title: "",
				centerDialogVisible: false,
				info: {
					id: "",
					title: "",
					participate: "",
					correct: "",
					courseId: "",
					status: "",
					createdUserId: this.$store.state.userInfo.id,
					createdUserName: this.$store.state.userInfo.userName,
				},
				options: [],
				cateListProps: {
					value: "lessonId", //匹配响应数据中的id
					label: "lessonName", //匹配响应数据中的name
					children: "clrLessonDOList", //匹配响应数据中的children
				},
			};
		},
		methods: {
			gb() {
				this.getInfo();
				this.getKc();
			},
			addZy() {
				this.title = "添加作业";
				this.disabled = false
				this.centerDialogVisible = true;
				this.centerDialogVisible = "";
				this.info.title = "";
				this.info.participate = "";
				this.info.correct = "";
				this.info.courseId = "";
				this.info.id = "";
				this.info.status = "";
			},
			bianji(row) {
				console.log(row.status);
				this.title = "编辑作业";
				this.disabled = true
				this.centerDialogVisible = true;
				this.info.title = row.title;
				this.info.participate = row.participate;
				this.info.correct = row.correct;
				this.info.courseId = row.courseId;
				this.info.id = row.id;
				this.info.status = row.status;
			},
			isStatus(item) {
				console.log(item.status == 1 ? 1 : 0);
				this.$http
					.post("/api/course/clrClasswork/update", {
						title: "",
						participate: "",
						correct: "",
						courseId: "",
						createdUserName: "",
						createdUserId: "",
						id: item.id,
						status: item.status == 1 ? 1 : 0,
					})
					.then((res) => {
						console.log(res);
						this.getInfo();
					});
			},
			queren() {
				let courseId = "";
				if (this.info.courseId.length > 0) {
					courseId = this.info.courseId[1];
				} else {
					courseId = this.info.courseId;
				}
				console.log(courseId);
				this.$refs.info.validate((valid) => {
					if (this.title == "添加作业") {
						this.$http.get(`/api/course/clrClasswork/check/${courseId}`, {}).then((res) => {
							console.log(res.data.data);
							let checkNum = res.data.data
							if (checkNum == 0) {
								this.$http.post("/api/course/clrClasswork/add/" + checkNum, {
										title: this.info.title,
										// participate: this.info.participate,
										// correct: this.info.correct,
										courseId: this.info.courseId[1],
										createdUserName: this.info.createdUserName,
										createdUserId: this.info.createdUserId,
										status: this.info.status,
									})
									.then((res) => {
										console.log(res);
										if (res.data.status == 0) {
											this.$message.success("添加成功");
											this.centerDialogVisible = false;
											this.getInfo();
										} else {
											this.$message.error("添加失败");
										}
									});
							} else if (checkNum == 1) {
								this.$confirm("该课时已关联作业, 是否覆盖?", "提示", {
										confirmButtonText: "确定",
										cancelButtonText: "取消",
										type: "warning",
									})
									.then(() => {
										this.$http.post("/api/course/clrClasswork/add/" + checkNum, {
												title: this.info.title,
												// participate: this.info.participate,
												// correct: this.info.correct,
												courseId: this.info.courseId[1],
												createdUserName: this.info.createdUserName,
												createdUserId: this.info.createdUserId,
												status: this.info.status,
											})
											.then((res) => {
												console.log(res);
												if (res.data.status == 0) {
													this.$message.success("添加成功");
													this.centerDialogVisible = false;
													this.getInfo();
												} else {
													this.$message.error("添加失败");
												}
											});
									})
							} else if (checkNum == 2) {
								this.$confirm("该课时已关联考试, 是否覆盖?", "提示", {
										confirmButtonText: "确定",
										cancelButtonText: "取消",
										type: "warning",
									})
									.then(() => {
										this.$http.post("/api/course/clrClasswork/add/" + checkNum, {
												title: this.info.title,
												// participate: this.info.participate,
												// correct: this.info.correct,
												courseId: this.info.courseId[1],
												createdUserName: this.info.createdUserName,
												createdUserId: this.info.createdUserId,
												status: this.info.status,
											})
											.then((res) => {
												console.log(res);
												if (res.data.status == 0) {
													this.$message.success("添加成功");
													this.centerDialogVisible = false;
													this.getInfo();
												} else {
													this.$message.error("添加失败");
												}
											});
									})
							}
						})
					} else if (this.title == "编辑作业") {
						this.$http.post("/api/course/clrClasswork/update", {
							title: this.info.title,
							// participate: this.info.participate,
							// correct: this.info.correct,
							courseId: courseId,
							createdUserName: this.info.createdUserName,
							createdUserId: this.info.createdUserId,
							id: this.info.id,
							status: this.info.status,
						}).then((res) => {
							console.log(res);
							if (res.data.status == 0) {
								this.$message.success("编辑成功");
								this.centerDialogVisible = false;
								this.getInfo();
							} else {
								this.$message.error("编辑失败");
							}
						});
					}
				});
			},
			pigai(row) {
				// this.$router.push({
				// 	path: "./check",
				// 	query: {
				// 		userOperationId: row.id,
				// 		title: row.title,
				// 	},
				// });
				let routeData = this.$router.resolve({
					path: "./check",
					query: {
						userOperationId: row.id,
						title: row.title,
					},
				});
				window.open(routeData.href, '_blank');
			},
			getInfo() {
				this.$http
					.post("/api/course/clrClasswork/select", {
						entity: {
							createdUserName: this.info.createdUserName,
							createdUserId: this.info.createdUserId,
						},
						page: {
							pageNum: this.pageNum,
							pageSize: this.pageSize,
						},
					})
					.then((res) => {
						console.log(res.data.data.list[0]);
						this.total = res.data.data.total;
						this.tableDate = res.data.data.list;
						console.log(this.tableDate);
					});
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size;
				//重新请求数据
				this.getInfo();
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage;
				//重新请求数据
				this.getInfo();
			},
			getKc() {
				this.$http
					.post("/api/course/clrCourse/selectCourseList", {})
					.then((res) => {
						// console.log(res.data.data);
						res.data.data.forEach((i) => {
							i.lessonId = i.courseId;
							i.lessonName = i.courseName;
						});
						this.options = res.data.data;
					});
			},
			chaKan(num) {
				this.$http
					.post("/api/course/clrCourse/selectCourseList", {})
					.then((res) => {
						// console.log(res.data.data);
						let arr1 = [];
						res.data.data.forEach((i) => {
							arr1.push(i.clrLessonDOList);
						});
						console.log(arr1);
					});
			},
		},
		created() {
			this.getInfo();
			this.getKc();
			this.chaKan();
		},
	};
</script>

<style scoped="scoped">
</style>
